import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface CommonModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    title?: string;
    description?: string;
    note?: string;
    expectedDate?: string;
    version?: string;
}

const CommonModal: React.FC<CommonModalProps> = ({
    showModal,
    setShowModal,
    title = "Coming Soon!",
    description = "This feature is Coming soon. Stay tuned for updates!",
    note,
    expectedDate,
    version
}) => {

    const handleClose = () => setShowModal(false)


    return (
        <Modal
            show={showModal}
            centered
            dialogClassName="modal-dialog modal-dialog-centered mw-600px"
            backdrop="static"
            keyboard={false}
            className="coming-soon-modal"
        >
            {/* Animated Header */}
            <Modal.Header
                className="border-0 pb-0"
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderTopLeftRadius: '0.75rem',
                    borderTopRightRadius: '0.75rem',
                    minHeight: '100px',
                    overflow: 'hidden',
                }}
            >
                {/* Animated Background Elements */}
                <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10">
                    <div className="position-absolute" style={{
                        top: '-30%',
                        right: '-10%',
                        width: '200px',
                        height: '200px',
                        background: 'white',
                        borderRadius: '50%',
                        animation: 'float 6s ease-in-out infinite',
                    }}></div>
                    <div className="position-absolute" style={{
                        bottom: '-50%',
                        left: '-10%',
                        width: '150px',
                        height: '150px',
                        background: 'white',
                        borderRadius: '50%',
                        animation: 'float 8s ease-in-out infinite reverse',
                    }}></div>
                </div>

                <Modal.Title className="w-100 text-center position-relative">
                    <div className="d-flex flex-column align-items-center">
                        {/* Simple Icon */}
                        <div className="symbol symbol-70 symbol-light-white mb-3">
                            <span className="symbol-label bg-white bg-opacity-20 rounded-3">
                                <i className="bi bi-hourglass-top fs-1 text-white"></i>
                            </span>
                        </div>
                        <h2 className="text-white mb-5 fw-bold">Coming Soon !</h2>
                    </div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-8 text-center">
                {/* Title */}
                <h3 className="mb-4 fw-bold text-dark">{title}</h3>

                {/* Description */}
                <p className="text-muted mb-6 fs-5 px-lg-4">
                    {description}
                </p>

                {/* Additional Details - Simple Cards */}
                <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
                    {expectedDate && (
                        <div className="d-flex align-items-center bg-light-primary px-5 py-3 rounded-4">
                            <i className="bi bi-calendar-check text-primary fs-4 me-3"></i>
                            <div className="text-start">
                                <small className="text-muted d-block">Expected</small>
                                <span className="fw-bold">{expectedDate}</span>
                            </div>
                        </div>
                    )}

                    {version && (
                        <div className="d-flex align-items-center bg-light-success px-5 py-3 rounded-4">
                            <i className="bi bi-tag text-success fs-4 me-3"></i>
                            <div className="text-start">
                                <small className="text-muted d-block">Version</small>
                                <span className="fw-bold">{version}</span>
                            </div>
                        </div>
                    )}
                </div>

                {/* Note - if provided */}
                {note && (
                    <div className="bg-light p-4 rounded-4 mt-4">
                        <div className="d-flex align-items-start">
                            <i className="bi bi-info-circle text-primary fs-5 me-3 mt-1"></i>
                            <p className="text-muted mb-0 text-start">{note}</p>
                        </div>
                    </div>
                )}

                {/* Decorative Element */}
                <div className="mt-6">
                    <span className="badge bg-light py-2 px-4 rounded-pill">
                        <i className="bi bi-stars text-warning me-2"></i>
                        <span className="text-muted">Stay tuned</span>
                    </span>
                </div>
                <div className='mt-6'>
                    <Button variant="light-primary" onClick={handleClose}>Got it !</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CommonModal;